import PropTypes from 'prop-types'
import React from 'react'

const SiteNavigationIcon = ({
   className,
   color,
   width,
   height
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g className={className} fill={color}>
         <path
            d="M14,18h-4c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h4c0.552,0,1-0.447,1-1v-4C15,18.447,14.552,18,14,18z "
         />
         <path
            d="M23,18h-4c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h4c0.552,0,1-0.447,1-1v-4C24,18.447,23.552,18,23,18z "
         />
         <path
            d="M5,18H1c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h4c0.552,0,1-0.447,1-1v-4C6,18.447,5.552,18,5,18z"
         />
         <path
            d="M4,13h7v3h2v-3h7v3h2v-4c0-0.553-0.448-1-1-1h-8V8h-2v3H3c-0.552,0-1,0.447-1,1v4h2V13z"
         />
         <circle
            cx="12"
            cy="3"
            r="3"
         />
      </g>
   </svg>
)

SiteNavigationIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   width: PropTypes.string
}

SiteNavigationIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   width: '24px'
}

export default React.memo(SiteNavigationIcon)
